import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const setHasMore: Mutation<MediaLibraryState> = (
  state,
  { essence, hasMore }: { essence: MediaLibraryEssence; hasMore: boolean }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(essence)

  if (mediaLibraryItem) {
    mediaLibraryItem.hasMore = hasMore

    state.value = mediaLibrary
  }
}

export default setHasMore
